import { json, useLocation, useParams } from 'react-router-dom'
import { apiFetch } from '../apihelper' // Import your apiFetch helper
import { ToastContainer, toast } from 'react-toastify'
import validateJSON from '../../util/jsonvalidation'
import Cookies from 'js-cookie'
import { getStoreIdValue } from '../../hooks/geturlstoreid'

export const registrationverification = async data => {
  try {
    const response = await apiFetch('auth/generate-verification-code', {
      method: 'POST',
      body: JSON.stringify(data)
    })
    return response
  } catch (error) {}
}

export const postDataToStore = async data => {
  // console.log(data)
  try {
    // Use apiFetch to send the POST request
    const response = await apiFetch('store', {
      method: 'POST',
      body: JSON.stringify(data) // apiFetch automatically handles headers
    })
    return response // Return the response data directly
  } catch (error) {
    // console.error('Error making API call:', error.message);
    toast.error('Access Denied.', {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    })
  }
}

export const UpdateMetaStore = async (data, storeId) => {
  // console.log(data)
  try {
    // Use apiFetch to send the POST request
    const response = await apiFetch(`store/${storeId}`, {
      method: 'PUT',
      body: JSON.stringify(data) // apiFetch automatically handles headers
    })
    return response // Return the response data directly
  } catch (error) {
    // console.error('Error making API call:', error.message);
    toast.error('Access Denied.', {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    })
    throw error // Re-throw the error so it can be handled elsewhere
  }
}

export const getshopifylist = async id => {
  try {
    // Array of types
    const types = ['products', 'collections', 'articles', 'pages']

    // Dynamically create the apiUrls array using the types
    const apiUrls = types.map(type => `shopify/${id}/type/${type}`)

    const promises = apiUrls.map(url =>
      apiFetch(url, {
        method: 'GET'
      })
    )

    // Wait for all API calls to resolve
    const responses = await Promise.all(promises)

    // Assuming that each API returns a JSON response, map over the responses to parse them
    const data = await Promise.all(
      responses.map(async response => {
        if (response.json) {
          return await response.json() // If response has json method
        }
        return response // Return as is if not a standard fetch response
      })
    )

    // Combine all the data into one object in the desired order
    const UrlData = {
      products: data[0],
      collections: data[1],
      articles: data[2],
      pages: data[3],
      categoryCount: 5,
      totalItemCount: 0
    }

    const categoryCount = Object.keys(UrlData).length - 2 // Subtracting 'policies' and 'categoryCount'

    const totalItemCount = Object.values(UrlData).reduce(
      (sum, currentArray) => {
        return sum + (Array.isArray(currentArray) ? currentArray.length : 0)
      },
      0
    )

    UrlData.categoryCount = categoryCount
    UrlData.totalItemCount = totalItemCount

    return UrlData
  } catch (error) {
    // Handle any errors that occur during the API requests
    // toast.error('Failed to fetch Shopify data. Please try again.', {
    //   position: "bottom-center",
    //   autoClose: 3000,
    //   hideProgressBar: true,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    // });
    throw error // Re-throw the error to be handled by the caller
  }
}

export const insertdataset = async dataToSend => {
  try {
    // Use apiFetch to send the POST request
    const response = await apiFetch('dataset/batch', {
      method: 'POST',
      body: JSON.stringify(dataToSend)
    })

    // Log the response to see what it's returning
    // console.log('Response from apiFetch:', response);

    // Check if response is already a parsed object or not
    let data
    if (typeof response === 'object' && !(response instanceof Response)) {
      // If response is a plain object, assume it's already the parsed data
      data = response
    } else if (response.json) {
      // If response has a .json() method, it's likely a Response object
      data = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    // if (response.ok || data.success) {
    //   // Assuming apiFetch might not have response.ok
    //   toast.success('Dataset Created Successfully', {
    //     position: 'bottom-center',
    //     autoClose: 3000,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true
    //   })
    // } else {
    //   console.error('Error sending data:', data)
    //   toast.error('Failed to send data', {
    //     position: 'bottom-center',
    //     autoClose: 3000,
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true
    //   })
    // }
    return data
  } catch (error) {
    console.error('Error:', error)
    toast.error('An error occurred while sending data', {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    })
  }
}

export const trainDataset = async idsArray => {
  try {
    const response = await apiFetch('dataset/batch/train', {
      method: 'POST',
      body: JSON.stringify(idsArray)
    })

    let data
    if (typeof response === 'object' && !(response instanceof Response)) {
      // If response is a plain object, assume it's already the parsed data
      data = response
    } else if (response.json) {
      // If response has a .json() method, it's likely a Response object
      data = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    // if (response.success === true) {
    //   toast.success('Training started successfully!', {
    //     position: "bottom-center",
    //     autoClose: 3000,
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //   });
    // } else {
    //   console.error('Error starting training:', data);
    //   toast.error('Failed to start training', {
    //     position: "bottom-center",
    //     autoClose: 3000,
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //   });
    // }

    return data
  } catch (error) {
    console.error('Error starting training:', error)
    toast.error('An error occurred while starting training', {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    })

    throw error
  }
}

class GetDataSet {
  constructor ({
    storeId = getStoreIdValue(),
    id = '',
    limit = '',
    page = '',
    sort = 'createdAt',
    order = 'DESC',
    search = '',
    type = '',
    status = '',
    shopify_dataset_type = '',
    training_processing = '',
    created_at_from = '',
    created_at_to = ''
  } = {}) {
    this.baseUrl = 'dataset'
    this.storeId = storeId || ''
    this.id = id
    this.limit = limit
    this.page = page
    this.sort = sort
    this.order = order
    this.search = search
    this.type = type
    this.status = status
    this.shopify_dataset_type = shopify_dataset_type
    this.training_processing = training_processing
    this.created_at_from = created_at_from
    this.created_at_to = created_at_to
  }

  // 🔹 Common guard for store_id
  ensureStore () {
    if (!this.storeId) {
      console.warn('No store_id found, skipping API call.')
      return false
    }
    return true
  }

  // Construct API URL
  constructUrl () {
    const params = new URLSearchParams()

    if (this.id) params.append('dataset_id', this.id)
    if (this.storeId) params.append('store_id', this.storeId)
    if (this.limit) params.append('limit', this.limit)
    if (this.order) params.append('order', this.order)
    if (this.type) params.append('type', this.type)
    if (this.page) params.append('page', this.page)
    if (this.status) params.append('status', this.status)
    if (this.shopify_dataset_type)
      params.append('shopify_dataset_type', this.shopify_dataset_type)
    if (this.training_processing)
      params.append('training_processing', this.training_processing)
    if (this.created_at_from)
      params.append('created_at_from', this.created_at_from)
    if (this.created_at_to) params.append('created_at_to', this.created_at_to)

    const queryString = params.toString()
    return `${this.baseUrl}${queryString ? `?${queryString}` : ''}`
  }

  // Fetch data
  async fetchData () {
    if (!this.ensureStore()) return null

    const url = this.constructUrl()
    try {
      const response = await apiFetch(url, { method: 'GET' })
      return typeof response === 'object' && !(response instanceof Response)
        ? response
        : await response.json()
    } catch (error) {
      console.error('fetchData error:', error)
      throw error
    }
  }

  // Search data
  async searchData (searchQuery, type) {
    if (!this.ensureStore()) return null

    const params = new URLSearchParams()
    params.append('store_id', this.storeId)
    if (searchQuery) params.append('search', searchQuery)
    if (type) params.append('type', type)

    const url = `${this.baseUrl}?${params.toString()}`
    try {
      const response = await apiFetch(url, { method: 'GET' })
      return typeof response === 'object' && !(response instanceof Response)
        ? response
        : await response.json()
    } catch (error) {
      console.error('searchData error:', error)
      throw error
    }
  }

  // Delete single data
  async singleDelete (id) {
    if (!this.ensureStore()) return null

    const url = `${this.baseUrl}/${id}`
    try {
      const response = await apiFetch(url, { method: 'DELETE' })
      return typeof response === 'object' && !(response instanceof Response)
        ? response
        : await response.json()
    } catch (error) {
      console.error('singleDelete error:', error)
      throw error
    }
  }

  // Delete multiple data
  async multipleDelete (idsArray) {
    if (!this.ensureStore()) return null

    const requestBody = { ids: idsArray }
    try {
      const response = await apiFetch(`${this.baseUrl}/batch/delete`, {
        method: 'POST',
        body: JSON.stringify(requestBody)
      })
      return typeof response === 'object' && !(response instanceof Response)
        ? response
        : await response.json()
    } catch (error) {
      console.error('multipleDelete error:', error)
      throw error
    }
  }

  // Set untrained
  async setUntrained (idsArray) {
    if (!this.ensureStore()) return null

    const requestBody = { ids: idsArray, status: 'inactive' }
    try {
      const response = await apiFetch(`${this.baseUrl}/batch/train`, {
        method: 'POST',
        body: JSON.stringify(requestBody)
      })
      return typeof response === 'object' && !(response instanceof Response)
        ? response
        : await response.json()
    } catch (error) {
      console.error('setUntrained error:', error)
      throw error
    }
  }

  // Set trained
  async setTrained (idsArray) {
    if (!this.ensureStore()) return null

    const requestBody = { ids: idsArray, status: 'active' }
    try {
      const response = await apiFetch(`${this.baseUrl}/batch/train`, {
        method: 'POST',
        body: JSON.stringify(requestBody)
      })
      return typeof response === 'object' && !(response instanceof Response)
        ? response
        : await response.json()
    } catch (error) {
      console.error('setTrained error:', error)
      throw error
    }
  }

  // Get counts
  async GetCount () {
    if (!this.ensureStore()) return null

    const training_category = [
      localStorage.getItem('chatbot'),
      'article',
      'faq',
      'unmatched'
    ]

    const fetchPromises = training_category.map(async category => {
      const params = new URLSearchParams()
      params.append('store_id', this.storeId)
      if (category) params.append('type', category)

      const url = `${this.baseUrl}?${params.toString()}`
      try {
        const response = await apiFetch(url, { method: 'GET' })
        const data =
          typeof response === 'object' && !(response instanceof Response)
            ? response
            : await response.json()
        return { category, count: data.pagination?.total || 0 }
      } catch (error) {
        console.error(`GetCount error for ${category}:`, error)
        return { category, count: 0 }
      }
    })

    return await Promise.all(fetchPromises)
  }

  // Update meta + title
  async updateMetaTitle (id, title, content, type, sourceType) {
    if (!this.ensureStore()) return null

    const metaData =
      sourceType === 'url' ? { url: content } : { content: content }

    const requestBody = {
      title,
      type,
      meta: {
        data: {
          title,
          ...metaData
        }
      }
    }

    const url = `${this.baseUrl}/${id}`
    try {
      const response = await apiFetch(url, {
        method: 'PUT',
        body: JSON.stringify(requestBody)
      })
      return typeof response === 'object' && !(response instanceof Response)
        ? response
        : await response.json()
    } catch (error) {
      console.error('updateMetaTitle error:', error)
      throw error
    }
  }

  // Update meta + title for FAQ
  async updateMetaTitleFaq (id, title, content, type) {
    if (!this.ensureStore()) return null

    const requestBody = {
      title,
      type,
      meta: {
        data: {
          question: title,
          answer: content
        }
      }
    }

    const url = `${this.baseUrl}/${id}`
    try {
      const response = await apiFetch(url, {
        method: 'PUT',
        body: JSON.stringify(requestBody)
      })
      return typeof response === 'object' && !(response instanceof Response)
        ? response
        : await response.json()
    } catch (error) {
      console.error('updateMetaTitleFaq error:', error)
      throw error
    }
  }
}

export default GetDataSet

export const getStore = async (type = '', status = '') => {
  // const userId = validateJSON(userdata).id
  // const userId = validateJSON(Cookies.get('user')).id
  const url = `store?${
    type ? `&type=${type}` : ''
  }&status=${status}&page=1&limit=0&search=&sort=createdAt&order=DESC`

  const response = await apiFetch(url, { method: 'GET' })

  let data
  if (typeof response === 'object' && !(response instanceof Response)) {
    data = response
  } else if (response.json) {
    data = await response.json()
  } else {
    throw new Error('Unexpected response format')
  }

  return data
}

export const updateStore = async (storeId, updateData) => {
  const url = `store/${storeId}`

  const response = await apiFetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updateData)
  })

  let data
  if (typeof response === 'object' && !(response instanceof Response)) {
    data = response
  } else if (response.json) {
    data = await response.json()
  } else {
    throw new Error('Unexpected response format')
  }

  return data
}

export const getStorebyID = async (storeId, navigate, logout) => {
  try {
    const response = await apiFetch(`store/${storeId}`, {
      method: 'GET'
    })

    let data
    if (typeof response === 'object' && !(response instanceof Response)) {
      data = response
    } else if (response.json) {
      data = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    if (data.status == 401 && navigate) {
      navigate('/')
      logout()
    }
    return data
  } catch (error) {
    console.error('Error deleting store:', error)
    throw error
  }
}

export const deleteStorebyID = async storeId => {
  try {
    const response = await apiFetch(`store/${storeId}`, {
      method: 'DELETE'
    })

    let data
    if (typeof response === 'object' && !(response instanceof Response)) {
      data = response
    } else if (response.json) {
      data = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return data
  } catch (error) {
    console.error('Error deleting store:', error)
    // throw error;
  }
}

export const authShopify = async url => {
  const sanitizedUrl = url.trim()
  const shopify_auth_redirect_host =
    process.env.REACT_APP_SHOPIFY_FRONTEND_HOST || 'http://localhost:3001'
  console.log('shopify_auth_redirect_host', shopify_auth_redirect_host)
  const response = `${process.env.REACT_APP_API_URL}/api/shopify/install?shop=${sanitizedUrl}&redirectUrl=${shopify_auth_redirect_host}`
  return response
}

export class GetChatLog {
  constructor () {
    this.baseUrl = 'chatlog'
  }

  async Get_Customer_List (
    store_id,
    signal = null,
    page = 1,
    limit = 10,
    sort = 'last_message_time',
    order = 'DESC'
  ) {
    try {
      const queryParams = new URLSearchParams({
        store_id,
        page: page.toString(),
        limit: limit.toString(),
        sort,
        order
      })

      const response = await apiFetch(
        `${this.baseUrl}/customer-list?${queryParams}`,
        {
          method: 'GET',
          signal
        }
      )

      if (!response) {
        console.error('No response received from server')
        return { success: false, data: [] }
      }

      // Handle both object response and fetch-style Response
      if (typeof response === 'object' && !(response instanceof Response)) {
        return response
      }

      if (typeof response.json === 'function') {
        return await response.json()
      }

      console.error('Unexpected response format')
      return { success: false, data: [] }
    } catch (error) {
      console.error('Get_Customer_List failed:', error)
      return { success: false, data: [] }
    }
  }

  async Get_Chat_List (
    store_id,
    customer_id,
    signal = null,
    page,
    limit,
    from_date = '',
    to_date = ''
  ) {
    try {
      const queryParams = new URLSearchParams()

      if (store_id) queryParams.append('store_id', store_id)
      if (customer_id) queryParams.append('customer_id', customer_id)
      if (page != null) queryParams.append('page', page)
      if (limit != null) queryParams.append('limit', limit)
      if (from_date) queryParams.append('from_date', from_date)
      if (to_date) queryParams.append('to_date', to_date)

      const response = await apiFetch(
        `${this.baseUrl}/chat-list?${queryParams.toString()}`,
        {
          method: 'GET',
          signal
        }
      )

      let data
      if (typeof response === 'object' && !(response instanceof Response)) {
        data = response
      } else if (response?.json) {
        data = await response.json()
      } else {
        console.error('Unexpected response format')
      }

      return data
    } catch (error) {
      console.error('There was a problem with the chat-list operation:', error)
    }
  }

  async Get_Chat_Log (store_id, chatlist_id, signal, page = 1, limit = 10) {
    try {
      const response = await apiFetch(
        `${this.baseUrl}?store_id=${store_id}&chat_id=${chatlist_id}&page=${page}&limit=${limit}&order=ASC`,
        {
          method: 'GET',
          signal
        }
      )
      let data
      if (typeof response === 'object' && !(response instanceof Response)) {
        data = response
      } else if (response.json) {
        data = await response.json()
      } else {
        console.error('Unexpected response format')
      }
      return data
    } catch (error) {
      console.error('There was a problem with the chat-log operation:', error)
    }
  }
}

export const DatasetSync = async store_id => {
  const response = await apiFetch(`dataset/sync/${store_id}`, {
    method: 'GET'
  })

  return response
}

export const Get_tickets = async (
  store_id,
  customer_id,
  limit = 10,
  status,
  priority,
  page = 1,
  search = '',
  ticket_number,
  sort = 'createdAt',
  customer_search,
  created_at_from,
  created_at_to,
  order = 'DESC'
) => {
  // Build the query string dynamically
  const queryParams = new URLSearchParams({
    ...(store_id && { store_id }),
    ...(customer_id && { customer_id }),
    ...(limit && { limit }),
    ...(status && { status }),
    ...(priority && { priority }),
    ...(page && { page }),
    ...(search && { search }),
    ...(ticket_number && { ticket_number }),
    ...(sort && { sort }),
    ...(customer_search && { customer_search }),
    ...(created_at_from && { created_at_from }),
    ...(created_at_to && { created_at_to }),
    ...(order && { order })
  })

  // Fetch the tickets
  const response = await apiFetch(`tickets?${queryParams.toString()}`, {
    method: 'GET'
  })

  return response
}

// export const Search_tickets = async (store_id, customer_id, user_id, limit, status, search) => {
//   // Build the query string dynamically
//   const queryParams = new URLSearchParams({
//     ...(store_id && {store_id}),
//     ...(customer_id && { customer_id }) ,
//     ...(user_id && { user_id }),
//     ...(limit && { limit }), // Add limit only if it's provided
//     ...(status && { status }),
//     ...(search && { search }),

//   });

//   // Fetch the tickets
//   const response = await apiFetch(`tickets?${queryParams.toString()}`, {
//     method: 'GET',
//   });

//   return response;
// };

export const update_tickets = async (ticket_id, status, priority) => {
  // Construct the request body dynamically
  const requestBody = {
    ...(status && { status }),
    ...(priority && { priority }),
    store_id: localStorage.getItem('store_id')
  }

  // Update the tickets with the dynamic body
  const response = await apiFetch(`tickets/${ticket_id}`, {
    method: 'PUT',
    body: JSON.stringify(requestBody)
  })

  return response
}

export const delete_tickets = async ticket_id => {
  const queryParams = new URLSearchParams({
    ...(ticket_id && { ticket_id })
  })

  //update the tickets
  const response = await apiFetch(`tickets/${ticket_id}`, {
    method: 'DELETE'
  })

  return response
}

export const getUserbyID = id => {
  const response = apiFetch(`users?id=${id}`, {
    method: 'GET'
  })

  return response
}

export const getstorelistbyID = id => {
  const response = apiFetch(`store/${id}`, {
    method: 'GET'
  })

  return response
}

export const feedback = async data => {
  try {
    const { store_id, name, email, message, attachments } = data

    const requestBody = {
      store_id,
      name,
      email,
      message
    }

    if (attachments && attachments.length > 0) {
      requestBody.attachments = attachments
    }

    const response = await apiFetch('support/submit', {
      method: 'POST',
      body: JSON.stringify(requestBody)
    })

    // Handle response
    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the feedback submission:', error)
  }
}


export const getsummarizedata = async store_id => {
  try {
    const response = await apiFetch(`store/${store_id}/homepage/summerize`, {
      method: 'GET'
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the feedback submission:', error)
  }
}

export const postconvoflow = async (store_id, config) => {
  try {
    const response = await apiFetch(`convoflow`, {
      method: 'POST',
      body: JSON.stringify({
        store_id: store_id,
        config: config,
        meta: {}
      })
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
      config = ''
    } else if (response.json) {
      responseData = await response.json()
      config = ''
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the convo flow post:', error)
  }
}

export const getconvoflow = async (store_id, id, page = 1, limit = 10) => {
  const queryParams = new URLSearchParams({
    ...(store_id && { store_id }),
    ...(id && { id }),
    page,
    limit,
    sort: 'createdAt',
    order: 'ASC'
  })

  try {
    const response = await apiFetch(`convoflow?${queryParams.toString()}`, {
      method: 'GET'
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the convo flow get:', error)
  }
}

export const updateconvoflow = async (
  id,
  position,
  config,
  status,
  meta = {}
) => {
  // console.log(id)
  // console.log(position)
  // console.log(config)
  try {
    const response = await apiFetch(`convoflow`, {
      method: 'PUT',
      body: JSON.stringify({
        id: id,
        position: position,
        config: config,
        status,
        meta: {}
      })
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
      config = ''
    } else if (response.json) {
      responseData = await response.json()
      config = ''
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the convo flow update:', error)
  }
}

export const updateconvoflowbyposition = async positionarray => {
  try {
    const response = await apiFetch(`convoflow/position`, {
      method: 'PATCH',
      body: JSON.stringify(positionarray)
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      // apiFetch might already return JSON
      responseData = response
    } else if (response.json) {
      // apiFetch returned a Response object
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData // ✅ return it so handleDragEnd gets data
  } catch (error) {
    console.error(
      'There was a problem with the convo flow update position:',
      error
    )
    return { success: false, error } // ✅ always return something
  }
}

export const deleteconvoflowbyid = async id => {
  // const queryParams = new URLSearchParams({
  //   ...(id && {id}),
  // });
  try {
    const response = await apiFetch(`convoflow/${id}`, {
      method: 'DELETE'
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the convo flow delete:', error)
  }
}

export const storelastsyncrecord = async (store_id, store_type) => {
  try {
    const response = apiFetch(`dataset/sync/log/${store_id}`, {
      method: 'GET'
    })
    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the store last sync record:', error)
  }
}

export const storesyncdataset = async (store_id, store_type) => {
  try {
    const response = apiFetch(`dataset/sync/${store_id}`, {
      method: 'GET'
    })
    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }
    return responseData
  } catch (error) {
    console.log('There was a problem with the store sync dataset:', error)
  }
}

export const chatagent = async data => {
  try {
    const response = apiFetch(`chat/agent`, {
      method: 'POST',
      body: JSON.stringify(data)
    })
    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      console.log('Unexpected response format')
    }
    return responseData
  } catch (error) {
    console.log('There was a problem with the Chat Agent:', error)
  }
}

// Notes

export class privatenotes {
  async getNotes (storeID, ticket_id) {
    return await apiFetch(
      `tickets/notes?store_id=${storeID}&page=1&ticket_id=${
        ticket_id || ''
      }&limit=10&search=&sort=createdAt&order=DESC`,
      {
        method: 'GET'
      }
    )
  }

  async createNote (noteData) {
    return await apiFetch('tickets/notes', {
      method: 'POST',
      body: JSON.stringify(noteData)
    })
  }

  async updateNote (noteId, updatedData) {
    return await apiFetch(`tickets/notes/${noteId}`, {
      method: 'PUT',
      body: JSON.stringify(updatedData)
    })
  }

  async deleteNote (noteId) {
    return await apiFetch(`tickets/notes/${noteId}`, { method: 'DELETE' })
  }

  // In your privatenotes service class
  async updateNotePositions (data) {
    return await apiFetch('tickets/notes/positions', {
      method: 'PATCH',
      body: JSON.stringify(data)
    })
  }
}

// Subscription

export const getsubscription = async (id, store_id, page) => {
  const queryParams = new URLSearchParams({
    ...(id && { id }),
    ...(store_id && { store_id }),
    ...(page && { page })
  })
  try {
    const response = await apiFetch(
      `subscription-plans?${queryParams.toString()}`,
      {
        method: 'GET'
      }
    )

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the get subscription:', error)
  }
}

export const postsubscription = async data => {
  try {
    const response = await apiFetch(`subscription-plans`, {
      method: 'POST',
      body: JSON.stringify(data)
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the post subscription:', error)
  }
}

//Subscription Plan

export const CreateSubscriptionPlan = async data => {
  try {
    const response = await apiFetch(`subscription-plans`, {
      method: 'POST',
      body: JSON.stringify(data)
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the post subscription:', error)
  }
}

//Get Subscription Plan

export const getsubscriptionplan = async (id, plan_ID, page) => {
  const queryParams = new URLSearchParams({
    ...(id && { id }),
    ...(plan_ID && { plan_ID }),
    ...(page && { page })
  })
  try {
    const response = await apiFetch(
      `subscription-plans?${queryParams.toString()}`,
      {
        method: 'GET'
      }
    )

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the get subscription plan:', error)
  }
}

// user-subscription

export const getusersubscription = async (
  id,
  user_id,
  plan_id,
  store_id,
  status,
  page = 1,
  limit = 10,
  search = '',
  sort = 'createdAt',
  order = 'DESC'
) => {
  const queryParams = new URLSearchParams({
    ...(id && { id }),
    // ...(user_id && { user_id }), // Uncomment if needed later
    ...(plan_id && { plan_id }),
    ...(store_id && { store_id }),
    ...(status && { status }),
    ...(page && { page }),
    ...(limit && { limit }),
    ...(search && { search }),
    ...(sort && { sort }),
    ...(order && { order })
  })
  try {
    const response = await apiFetch(
      `user-subscriptions?${queryParams.toString()}`,
      {
        method: 'GET'
      }
    )

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the get user subscription:', error)
  }
}

// get start and end Date

export const GetPayPalSubscriptionDates = async subscriptionId => {
  try {
    const response = await apiFetch(
      `paypal-subscription/verify-subscription?subscriptionId=${subscriptionId}`,
      {
        method: 'GET'
      }
    )

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    const { startDate, endDate } = responseData?.data || {}

    return { startDate, endDate }
  } catch (error) {
    console.error('Failed to verify PayPal subscription:', error)
    return { startDate: null, endDate: null }
  }
}

// new paypal subscription
export const CreateUserPayPalSubscription = async data => {
  try {
    const response = await apiFetch(`user-subscriptions/paypal`, {
      method: 'POST',
      body: JSON.stringify(data)
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    return error
    // console.error('There was a problem with the post subscription:', error)
  }
}

// create new custom

export const CreateCustomSubscription = async data => {
  try {
    const response = await apiFetch(`user-subscriptions`, {
      method: 'POST',
      body: JSON.stringify(data)
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    return error
    // console.error('There was a problem with the post subscription:', error)
  }
}

//update user-subscription

export const UpdateUserSubscription = async (id, data) => {
  try {
    const response = await apiFetch(`user-subscriptions/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the post subscription:', error)
  }
}

//Paypal Subscription ID verify

export const CancelPaypalSubscription = async data => {
  try {
    const response = await apiFetch(`paypal-subscription/cancel-subscription`, {
      method: 'POST',
      body: JSON.stringify(data)
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the post subscription:', error)
  }
}

export const Settingsticketimap = async data => {
  try {
    const response = await apiFetch(`tickets/imap-config`, {
      method: 'POST',
      body: JSON.stringify(data)
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the post subscription:', error)
  }
}

export const GetSettingsticketimap = async store_id => {
  try {
    const queryParams = new URLSearchParams({
      store_id
    })

    const response = await apiFetch(
      `tickets/imap-config?${queryParams.toString()}&page=1&limit=10&sort=createdAt&order=DESC`,
      {
        method: 'GET'
      }
    )

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem fetching the IMAP config:', error)
  }
}

export const ValidatewebsiteUrl = async url => {
  try {
    const response = await apiFetch(`website/validate-url`, {
      method: 'POST',
      body: JSON.stringify(url)
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the post subscription:', error)
  }
}

export const validatesitemapurl = async url => {
  try {
    const response = await apiFetch(`website/validate-sitemap`, {
      method: 'POST',
      body: JSON.stringify(url)
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the post subscription:', error)
  }
}

export const Validatescript = async data => {
  try {
    const response = await apiFetch(`website/validate-script`, {
      method: 'POST',
      body: JSON.stringify(data)
    })

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the post subscription:', error)
  }
}

export const reportsnewusers = async (
  store_id,
  created_at_from,
  created_at_to
) => {
  const queryParams = new URLSearchParams({
    ...(store_id && { store_id }),
    ...(created_at_from && { created_at_from }),
    ...(created_at_to && { created_at_to })
  })
  try {
    const response = await apiFetch(
      `reports/new-users?${queryParams.toString()}`,
      {
        method: 'GET'
      }
    )

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the get subscription plan:', error)
  }
}

export const tokenusage = async (store_id, created_at_from, created_at_to) => {
  const queryParams = new URLSearchParams({
    ...(store_id && { store_id }),
    ...(created_at_from && { created_at_from }),
    ...(created_at_to && { created_at_to })
  })
  try {
    const response = await apiFetch(
      `reports/token-usage?${queryParams.toString()}`,
      {
        method: 'GET'
      }
    )

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the get subscription plan:', error)
  }
}

export const fetchAvgSessionTime = async (
  store_id,
  created_at_from,
  created_at_to
) => {
  const queryParams = new URLSearchParams({
    ...(store_id && { store_id }),
    ...(created_at_from && { created_at_from }),
    ...(created_at_to && { created_at_to })
  })
  try {
    const response = await apiFetch(
      `reports/average-session-activity?${queryParams.toString()}`,
      {
        method: 'GET'
      }
    )

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the get subscription plan:', error)
  }
}

export const fetchAvgResponseTime = async (
  store_id,
  created_at_from,
  created_at_to
) => {
  const queryParams = new URLSearchParams({
    ...(store_id && { store_id }),
    ...(created_at_from && { created_at_from }),
    ...(created_at_to && { created_at_to })
  })
  try {
    const response = await apiFetch(
      `reports/average-response-time?${queryParams.toString()}`,
      {
        method: 'GET'
      }
    )

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the get subscription plan:', error)
  }
}

export const messagecount = async (
  store_id,
  created_at_from,
  created_at_to
) => {
  const queryParams = new URLSearchParams({
    ...(store_id && { store_id }),
    ...(created_at_from && { created_at_from }),
    ...(created_at_to && { created_at_to })
  })
  try {
    const response = await apiFetch(
      `reports/message-count?${queryParams.toString()}`,
      {
        method: 'GET'
      }
    )

    let responseData
    if (typeof response === 'object' && !(response instanceof Response)) {
      responseData = response
    } else if (response.json) {
      responseData = await response.json()
    } else {
      throw new Error('Unexpected response format')
    }

    return responseData
  } catch (error) {
    console.error('There was a problem with the get subscription plan:', error)
  }
}

export const uploadCustomDataset = async (file, segmentType) => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('store_id', localStorage.getItem('store_id'))

    const response = await apiFetch(
      `upload/batch-custom-dataset/${segmentType}`,
      {
        method: 'POST',
        body: formData
      }
    )
    // console.log(response.ok)
    if (response instanceof Response) {
      if (response.status === 200 || response.status === 201) {
        return await response.json()
      } else {
        console.warn(`Request failed with status: ${response.status}`)
      }
    }

    if (typeof response === 'object') {
      console.log(response)

      return response
    }

    throw new Error('Unexpected response format')
  } catch (error) {
    console.error('There was a problem with the dataset upload:', error)
  }
}

export const deleteUploadedFile = async filename => {
  try {
    const response = await apiFetch(`upload/delete`, {
      method: 'POST',
      body: JSON.stringify({ filename })
    })

    return response
  } catch (error) {
    console.error('Failed to delete uploaded file:', error)
    return { success: false, message: 'Delete failed' }
  }
}

export const getUserFromToken = async () => {
  try {
    const response = await apiFetch('auth/user', {
      method: 'GET'
    })

    // ✅ Check response structure
    if (response?.success && response?.data) {
      return response.data
    } else {
      console.warn('Invalid response format or user not found:', response)
      return null
    }
  } catch (err) {
    console.error('Failed to fetch user:', err)
    return null
  }
}

export const botIntructions = async bodyData => {
  try {
    const response = await apiFetch('bots/instruction/generate', {
      method: 'POST',
      body: JSON.stringify(bodyData)
    })

    // ✅ Check response structure
    if (response?.success && response?.data) {
      return response.data
    } else {
      console.warn('Invalid response format or user not found:', response)
      return null
    }
  } catch (err) {
    console.error('Failed to fetch user:', err)
    return null
  }
}
